@if (rating) {
  <div>
    <i class="vive-preferred-vendor fs-28"></i>
  </div>
}
